import { render } from "./DetailView.vue?vue&type=template&id=329199bb"
import script from "./DetailView.vue?vue&type=script&lang=ts"
export * from "./DetailView.vue?vue&type=script&lang=ts"

import "./DetailView.vue?vue&type=style&index=0&id=329199bb&lang=scss"
script.render = render

export default script